<template>
  <div class="q-product-actions">

    <!-- Attribute pickers -->
    <div v-if="product.attList && product.attList.length" class="mb-3">
      <div v-for="group in product.attList" :key="group.id">
        <Picker :key="pickerReset + '-' + group.id" :group="group" @update="updateAttributes" />
      </div>
      <!-- Estado de la variante resuelta -->
      <p v-if="variantExists && allAttrsChosen && !hasVariant" class="q-variant-msg q-variant-msg--err">
        Esa combinación no está disponible
      </p>
      <p v-else-if="hasVariant" class="q-variant-msg q-variant-msg--ok">
        Stock: {{ selectedItem.variant.stock }}
      </p>
    </div>

    <!-- Quantity + Add to cart -->
    <div class="q-add-to-cart">
      <div class="q-qty-control">
        <button class="q-qty-btn" @click.prevent="updateProductAmount(selectedItem.amount - 1)">−</button>
        <input
          type="number"
          v-model.number="itemAmount"
          class="q-qty-input"
          min="1"
          @input="updateValue"
        />
        <button class="q-qty-btn" @click.prevent="updateProductAmount(selectedItem.amount + 1)">+</button>
      </div>
      <button
        type="button"
        class="btn btn-primary btn-lg q-add-btn"
        :disabled="!productReady()"
        @click="addToBasket"
      >
        <i class="bi bi-cart-plus me-2"></i>Agregar al carrito
      </button>
      <button
        type="button"
        class="btn btn-primary btn-lg q-buy-now-btn q-add-btn"
        :disabled="!productReady()"
        @click="buyNow"
      >
        <i class="bi bi-lightning-charge me-2"></i>Comprar ahora
      </button>
    </div>

    <!-- Alerts -->
    <transition name="q-fade">
      <div v-if="showSuccess" class="alert alert-success alert-dismissible mt-3 py-2" role="alert">
        <i class="bi bi-check-circle me-2"></i>{{ successMessage }}
        <button type="button" class="btn-close py-2" @click="showSuccess = false"></button>
      </div>
    </transition>
    <transition name="q-fade">
      <div v-if="showError" class="alert alert-danger alert-dismissible mt-3 py-2" role="alert">
        <i class="bi bi-exclamation-circle me-2"></i>{{ errorMessage }}
        <button type="button" class="btn-close py-2" @click="showError = false"></button>
      </div>
    </transition>

  </div>
</template>

<script>
import Picker from "./AttributePicker.vue";
import { mapGetters, mapMutations } from "vuex";

export default {
  components: { Picker },
  data() {
    return {
      showError: false, showSuccess: false,
      errorMessage: "", successMessage: "",
      filterAtts: [],
      pickerReset: 0,
      selectedItem: { key: 0, product: {}, amount: 1, variant: {}, pricelist: 0 },
    };
  },
  computed: {
    ...mapGetters({
      configuration: "ecommerce/configuration",
      product: "ecommerce/product",
    }),
    itemAmount: {
      get() { return this.selectedItem.amount; },
      set(value) {
        if (!Number.isNaN(value) && value > 0) {
          if (this.configuration.sale_without_stock) {
            this.selectedItem.amount = value;
          } else {
            const stock = Object.entries(this.selectedItem.variant).length === 0
              ? this.selectedItem.product.stock
              : this.selectedItem.variant.stock;
            if (value <= stock) {
              this.selectedItem.amount = value;
            } else {
              this.sendError("Stock insuficiente");
            }
          }
        }
      },
    },
    variantExists() {
      return this.product.variants !== undefined && this.product.variants.length > 0;
    },
    hasVariant() {
      return Object.entries(this.selectedItem.variant).length !== 0;
    },
    allAttrsChosen() {
      const groups = this.product.attList || [];
      return groups.length > 0 && this.filterAtts.length >= groups.length;
    },
  },
  watch: {
    product(newproduct) {
      if (newproduct !== undefined && newproduct.id !== undefined) {
        let item = JSON.parse(JSON.stringify(newproduct));
        delete item.attList; delete item.variants; item.attList = [];
        this.selectedItem.product = item;
      }
    },
    filterAtts() {
      let arr = [];
      this.product.attList.forEach(group => {
        group.attributes.forEach(att => {
          if (this.filterAtts.includes(att.id)) arr.push(att);
        });
      });
      this.selectedItem.product.attList = JSON.parse(JSON.stringify(arr));
    },
  },
  methods: {
    ...mapMutations({
      addToBasketMutator: "ecommerce/ADD_TO_BASKET",
      setProduct: "ecommerce/SET_PRODUCT",
    }),
    updateProductAmount(q) {
      if (q < 1) return;
      if (!this.configuration.sale_without_stock) {
        const stock = Object.entries(this.selectedItem.variant).length === 0
          ? this.selectedItem.product.stock
          : this.selectedItem.variant.stock;
        if (q > stock) { this.sendError("Stock insuficiente"); return; }
      }
      this.selectedItem.amount = q;
    },
    updateAttributes(id) {
      if (id !== 0) {
        const idx = this.filterAtts.findIndex((i) => i === id);
        if (idx !== -1) this.filterAtts.splice(idx, 1);
        else this.filterAtts.push(id);
      }
      this.resolveVariant();
    },
    resolveVariant() {
      this.selectedItem.variant = {};
      if (!this.variantExists || !this.allAttrsChosen) return;
      const match = this.product.variants.find((v) => {
        const ids = v.attributes.map((a) => a.id);
        return this.filterAtts.every((fa) => ids.includes(fa));
      });
      // Asignar siempre la variante encontrada; el stock lo gatea productReady()
      // (si está agotada, hasVariant=true muestra "Stock: 0" y deshabilita los botones).
      if (match) this.selectedItem.variant = match;
    },
    addToBasket() {
      this.selectedItem.key = String(this.selectedItem.product.id);
      if (Object.entries(this.selectedItem.variant).length !== 0) {
        this.selectedItem.key += "-" + String(this.selectedItem.variant.id);
      }
      this.addToBasketMutator(this.selectedItem);
      this.sendSuccess("Producto agregado al carrito");
      this.clearProductDetail();
    },
    buyNow() {
      this.selectedItem.key = String(this.selectedItem.product.id);
      if (Object.entries(this.selectedItem.variant).length !== 0) {
        this.selectedItem.key += "-" + String(this.selectedItem.variant.id);
      }
      this.addToBasketMutator(this.selectedItem);
      this.$router.push({ name: "CheckoutFlow", params: { company: this.$route.params.company } });
    },
    productReady() {
      if (this.configuration.variant_check && this.variantExists) {
        if (Object.entries(this.selectedItem.variant).length !== 0) {
          return this.configuration.sale_without_stock || this.selectedItem.amount <= this.selectedItem.variant.stock;
        }
      } else {
        return this.configuration.sale_without_stock || this.selectedItem.amount <= this.product.stock;
      }
      return false;
    },
    sendError(message) {
      this.errorMessage = message; this.showError = true;
      setTimeout(() => { this.showError = false; }, 3000);
    },
    sendSuccess(message) {
      this.successMessage = message; this.showSuccess = true;
      setTimeout(() => { this.showSuccess = false; }, 3000);
    },
    clearProductDetail() {
      this.filterAtts = [];
      this.pickerReset++; // remonta los AttributePicker para limpiar su selección interna
      this.selectedItem.key = 0; this.selectedItem.amount = 1; this.selectedItem.variant = {};
    },
    updateValue(event) {
      const value = event.target.value;
      this.selectedItem.amount = String(value).length <= 4 ? value : parseInt(String(value).substring(0, 4));
    },
  },
  mounted() {
    if (this.product !== undefined && this.product.id !== undefined) {
      let item = JSON.parse(JSON.stringify(this.product));
      delete item.attList; delete item.variants;
      this.selectedItem.product = item;
    }
  },
  beforeDestroy() { this.setProduct({}); },
};
</script>

<style scoped>
.q-add-to-cart {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.q-qty-control {
  display: flex;
  align-items: center;
  border: 1px solid var(--q-border);
  border-radius: var(--q-radius);
  overflow: hidden;
}
.q-qty-btn {
  background: var(--q-bg-elevated);
  border: none;
  width: 36px; height: 40px;
  color: var(--q-text-muted);
  font-size: 16px;
  cursor: pointer;
  transition: background var(--q-transition);
  display: flex; align-items: center; justify-content: center;
}
.q-qty-btn:hover { background: var(--primary-color); color: #ffffff; }
.q-qty-input {
  width: 50px; height: 40px;
  border: none; border-left: 1px solid var(--q-border); border-right: 1px solid var(--q-border);
  text-align: center;
  background: var(--q-bg-surface);
  color: var(--q-text);
  font-family: var(--q-font-mono);
  font-size: 14px;
  -moz-appearance: textfield;
}
.q-qty-input::-webkit-outer-spin-button,
.q-qty-input::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.q-qty-input:focus { outline: none; }

.q-add-btn { flex: 1; min-width: 160px; }
.q-add-btn:disabled { opacity: 0.4; cursor: not-allowed; }

.q-buy-now-btn {
  background-color: transparent;
  border: 1px solid var(--primary-color);
  color: var(--primary-color);
  transition: background-color var(--q-transition), color var(--q-transition);
}
.q-buy-now-btn:hover:not(:disabled) {
  background-color: var(--primary-color);
  color: #ffffff;
}

.q-fade-enter-active, .q-fade-leave-active { transition: opacity 0.3s ease; }
.q-fade-enter, .q-fade-leave-to { opacity: 0; }

.q-variant-msg {
  font-family: var(--q-font-mono); font-size: 12px; margin: 8px 0 0;
}
.q-variant-msg--ok { color: var(--primary-color); }
.q-variant-msg--err { color: var(--alert-color, #dc2626); }
</style>
